<div class="registration-container">
  <div class="spinner-holder" *ngIf="submitting">
    <div>
      <app-spinner></app-spinner>
      <h1>Working on it!</h1>
    </div>
  </div>
  <div class="gifts" *ngIf="step === 'one' && itemUnderEdit">
    <img class="hero" src="/assets/gift/holiday-2023.png" />
    <a class="cart-icon" routerLink="/gift/cart"><i class="fa fa-shopping-cart"></i><span>{{cart.items.length}}</span></a>
    <div class="form-title">Create Your Gift
      <a class="faq-link" href="https://help.tyt.com/category/55-gift-memberships" target="_blank">Learn More</a>
    </div>
    <error-message [producer]="this"></error-message>

    <app-form #form action="/gift" [handler]="this" class="form-fields">
      <error-message></error-message>
      <div class="field-set">
        <div class="field-row">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Recipient Name</mat-label>
            <input errorHighlight matInput type="text" name="recipient-name" [(ngModel)]="itemUnderEdit.recipientName"
              required />
            <mat-hint>How should we address the recipient? Can be a nickname.</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Recipient Email</mat-label>
            <input errorHighlight matInput type="email" autocomplete="off" id="recipient-email" name="recipient-email"
              [(ngModel)]="itemUnderEdit.recipientEmail" required />
            <mat-hint>Where should we send the gift? Make sure this is correct!</mat-hint>
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Your Name</mat-label>
          <input 
            errorHighlight
            matInput
            type="text" 
            autocomplete="given-name" 
            name="purchaser-name" 
            [(ngModel)]="itemUnderEdit.purchaserName" 
            required 
            />
          <mat-hint>As displayed to the recipient, feel free to use a nickname if you want.</mat-hint>
        </mat-form-field>

        <div *ngIf="!user" class="form-group text-field">
          <label for="purchaser-email">Your Email Address</label>
          <input errorHighlight type="email" autocomplete="email" class="form-control" id="purchaser-email"
            name="purchaser-email" [(ngModel)]="cart.email" required />
          <em>We'll send a confirmation email to this address.</em>
        </div>

        <h1>Membership Options</h1>

        <div class="product-selector">
          <div class="product-row plan">
            <div class="product-name">
              TYT &nbsp; <app-plus-tag></app-plus-tag>
            </div>
            <div *ngFor="let product of products">
              {{ product.name }}
              <a href="javascript:;" class="card-tooltip" aria-role="tooltip" [attr.aria-label]="benefitsA11y(product)">
                <i class="fa fa-question-circle" aria-hidden="true"></i>
                <ul class="tooltiptext" id="{{product.id}}-benefits">
                  <li *ngFor="let benefit of product.benefits">{{ benefit }}</li>
                </ul>
              </a>
            </div>
          </div>
          <ng-container *ngFor="let period of periods">
            <div class="product-row" *ngIf="period.requiresAccount ? signedIn : true">
              <div class="product-name">{{ period.name }}</div>

              <div *ngFor="let product of products">
                <a href="javascript:;" 
                  [attr.aria-label]="priceA11y(product, period)"
                  (click)="selectMembershipOption(product, period)" 
                  class="btn price table-item"
                  [class.selected]="isSkuSelected(product, period)" 
                  [id]="skuFor(product, period)">
                  <div class="price-container">
                    <span *ngIf="previousPriceFor(product, period)" class="previous-price">{{ previousPriceFor(product, period) | currency: 'USD' }}</span>
                    <span [ngClass]="{'discounted-price': previousPriceFor(product, period)}">{{ priceFor(product, period) | currency: 'USD' }}{{ period.priceSuffix }}</span>
                  </div>
                </a>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="alert alert-danger" *ngIf="selectProduct">
          Please select the membership you wish to send
        </div>
        <div class="alert alert-info" *ngIf="!user">
          Looking to send a recurring membership gift? Please <a routerLink="/login">Sign In</a> first.
        </div>
      </div>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Message (optional)</mat-label>
        <textarea 
          matInput 
          rows="4" 
          name="message"
          [(ngModel)]="itemUnderEdit.message"
          ></textarea>
        <mat-hint>Include a message with your gift.</mat-hint>
      </mat-form-field>
      <section>
        <h1>Delivery</h1>

        <div class="delivery">
          <div class="delivery-options">
            <button aria-label="Deliver this gift right away after purchase" type="button" class="btn immediately"
              [class.selected]="itemUnderEdit.deliverImmediately"
              (click)="itemUnderEdit.deliverImmediately = true;">Immediately</button>
            <button aria-label="Deliver this gift on a specified date" type="button" class="btn selection"
              [class.selected]="!itemUnderEdit.deliverImmediately"
              (click)="itemUnderEdit.deliverImmediately = false">Selected Date</button>
          </div>
          <div *ngIf="!itemUnderEdit.deliverImmediately">
            <br />
            <div class="form-group">
              <label>Send my gift on</label>
              <input aria-label="Send my gift on" errorHighlight type="date" class="form-control" id="deliver-at"
                name="deliver-at" [(ngModel)]="itemUnderEdit.deliverAt" placeholder="MM/DD/YYYY" />
            </div>
          </div>
        </div>
      </section>
      <section>
        <h1>Theme</h1>
        <div class="theme">
          <div class="theme-container">
            <div *ngFor="let theme of themes" id="{{theme.id}}" class="person">
              <a href="javascript:;" 
                class="theme" 
                (click)="setEmailTheme(theme.id)"
                [class.selected]="itemUnderEdit.themeName === theme.id" 
                [attr.aria-label]="themeButtonA11y(theme)">
                <div class="theme-logo" [responsiveBackgroundImage]="theme.image"></div>
                {{theme.name}}
              </a>
            </div>
          </div>
          <div class="alert alert-danger" *ngIf="selectTheme">
            Please select the theme for your gift
          </div>
        </div>
      </section>

      <div class="actions">
        <app-form-submit-button class="cart-buttons" (click)="addToCart()">
          {{ editCart ? 'Save Changes' : 'Add to Cart' }}
        </app-form-submit-button>
        <a class="btn" *ngIf="cart.items.length > 0" routerLink="/gift/cart">Cancel</a>
      </div>


    </app-form>


  </div>

  <div class="cart" [class.submitting]="submitting" *ngIf="step === 'two'">
    <a class="cart-icon" routerLink="/gift/cart">
      <mat-icon>shopping_cart</mat-icon>
      <span>{{cart.items.length}}</span>
    </a>
    <div class="form-title">Your Cart</div>

    <div class="gift-item" *ngFor="let giftItem of cart.items; let i = index">
      <div class="gift-item-title">
        <h1>Gift for {{giftItem.recipientName}}</h1>
        <div class="gift-item-name">
          <span class="tag">TYT &nbsp; <app-plus-tag></app-plus-tag></span>
          <span class="name">{{ giftProductName(giftItem)}}</span>
        </div>
      </div>

      <div>
        <label class="key">To:</label>
        {{giftItem.recipientName}} &lt;{{giftItem.recipientEmail}}&gt;
      </div>

      <div>
        <label class="key">From:</label>
        {{giftItem.purchaserName}}
      </div>

      <div>
        <label class="key">Gift Message:</label>
        {{giftItem.message}}
      </div>

      <div>
        <label class="key">Email Theme:</label>
        {{getThemeName(giftItem.themeName)}}
      </div>

      <div>
        <label class="key">Delivery:</label>
        <ng-container *ngIf="!giftItem.deliverImmediately">
          <time [attr.datetime]="giftItem.deliverAt"
            >{{ giftItem.deliverAt | date: 'shortDate'}}</time>
        </ng-container>
        <ng-container *ngIf="giftItem.deliverImmediately">
          <em>Immediately</em>
        </ng-container>
      </div>

      <div class="cart-item-options">
        <span class="item-price">{{giftItem.price | currency : 'USD'}}</span>

        <div class="spacer"></div>

        <button mat-button routerLink="/gift/edit/{{giftItem.uuid}}">
          <mat-icon>edit</mat-icon>
          Edit
        </button>
        <button mat-button (click)="removeGiftItem(giftItem)">
          <mat-icon>delete</mat-icon>
          Remove
        </button>
      </div>
      <hr />
    </div>

    <div class="actions" style="justify-content: center;">
      <a routerLink="/gift/add" mat-raised-button color="primary" title="Add another gift to your cart">Add another gift</a>
    </div>

    <h1>Summary</h1>
    <div class="alert alert-info with-icon muted">
      <mat-icon>info</mat-icon>
      <div>
        Here is a summary of the charges you can expect if you proceed.

        <div class="total">
          <div class="total-price">
            <div class="price">{{cart.totals.total | currency : 'USD'}}</div>
            <div>Charged immediately</div>
          </div>

          <div class="total-price" [class.not-applicable]="!cart.totals.monthly">
            <div class="price">{{(cart.totals.monthly || 0) | currency: 'USD'}}/mo</div>
            <div>
              Charged each following month
              <span *ngIf="!cart.totals.monthly">(Not applicable)</span>
            </div>
          </div>

          <div class="total-price" [class.not-applicable]="!cart.totals.annually">
            <div class="price">{{(cart.totals.annually || 0) | currency: 'USD'}}/yr</div>
            <div>
              Charged each following year
              <span *ngIf="!cart.totals.annually">(Not applicable)</span>
            </div>
          </div>
        </div>

        <ng-container *ngIf="cart.totals.monthly || cart.totals.annually">
          Recurring gifts can be cancelled at any time via the Membership Accounts page under Settings 
          on TYT.com. Recurring charges may not be grouped together as shown above, but will be charged on the same
          renewal dates.
          <a target="_blank" href="https://help.tyt.com/article/164-how-do-cancel-a-gift-membership">Learn More</a>
        </ng-container>

      </div>
    </div>

    <hr/>

    <credit-card-selector [validityError]="validityError" [newCardMessage]="newCardMessage"
      #ccElement></credit-card-selector>
      <br/>
    <error-message [producer]="this"></error-message>

    <hr/>

    <div class="purchase">
      <div class="terms">
        By clicking "Purchase" you agree to TYT's
        <a href="javascript:;" href="https://tyt.com/terms" target="_blank">Terms of Use</a>
        and <a href="javascript:;" href="https://tyt.com/privacy" target="_blank">Privacy Policy</a>
      </div>
      <app-form-submit-button class="cart-buttons" (click)="proceedToPayment()"
        title="Purchase your gift(s) now">Purchase</app-form-submit-button>
    </div>
  </div>

  <div class="complete" *ngIf="step === 'three'">
    <div class="form-title">Gift Purchase Complete</div>

    <h4 class="thank-support">Thanks for your support!</h4>
    <div class="notes">
      <p>A copy of your gift message(s) will be sent to the email account tied to your TYT membership. If you selected
        immediate delivery, your recipient(s) should also have received their gift(s).</p>
      <p>Any renewing subscriptions you have purchased as gifts are now available to manage on your <a
          href="javascript:;" routerLink="/account">Account</a> page.</p>
      <p>If you have questions, please contact <a href="mailto:support@tytnetwork.com">support@tytnetwork.com</a></p>
    </div>

    <hr />

    <a class="btn return" routerLink="/gift/add">Buy another gift</a>
    <br />

    <a class="btn return" routerLink="/account">Return to my account page</a>
  </div>

</div>
